<template>


<draggable 
v-model="listdata"
class="list-group" 
@start="start" 
@end="end" 
v-bind="dragOptions"
handle=".handle"
item-key="id">
<template #item="{element, index}">



<div class="grid ml-0 mr-0" >	



<div class="col-11">
<div class="grid ml-0 mr-0"  @click="gotoPage('FlowAuditDayRoot',{auditday_id:element.id})"> 

<div class="col-2 md:col-1 mt-0 mb-0 handle">
<span class="material-icons-outlined md-24 mt-4 text-primary p-link"
>
drag_handle
</span>
</div>

<div class="col-2 md:col-1 mt-0 mb-0 " >
<p class="text-primary p-link mt-4 mb-4" >{{index+1}}.  bölüm</p>
</div>

<div class="col mt-0 mb-0">
<p class="text-primary p-link mt-4 mb-4" v-if="element.questionlist">{{element.questionlist.name}}</p>
<p class="text-orange-700 p-link mt-4 mb-4 font-bold" v-else>Soru listesi belirlenmemiş</p>
</div>

<div class="col-2 md:col-1 mt-0 mb-0">
<p class="text-primary p-link mt-4 mb-4">{{element.duration}} saat</p>
</div>


</div>


</div>




<!-- menu -->
<div class="col-1">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,element.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+element.id" class="p-button-primary p-button-text p-button-sm mt-3"   />
<Menu :id="'overlay_menu'+element.id" :ref="'menu'+element.id" :model="menuitems" :popup="true">
 <template #item="{item}">  
  <template v-if="item.label=='Sil'">
    
      <a class="p-menuitem-link" 
      role="menuitem" 
      @click="item.command(element.id)"
      >
      <span :class="'p-menuitem-icon '+item.icon"></span>
      <span class="p-menuitem-text">{{item.label}}</span>
      <span class="p-ink"></span></a>
  </template>
  <template v-else>
    <a class="p-menuitem-link" 
      role="menuitem" 
      @click="item.command(element.id)"
      >
      <span :class="'p-menuitem-icon '+item.icon"></span>
      <span class="p-menuitem-text">{{item.label}}</span>
      <span class="p-ink"></span></a>
  </template>

</template>
</Menu>
</div>
<!-- menu -->

</div>











</template>
</draggable>
</template>

<script>
export default {

  name: 'SortableAuditDays',
  props:["data"],
  data () {
    return {
    	 drag:false,
       listdata:[],
    	 menuitems: [
    		{
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                routename:this.routename,
                route_param:this.route_param,
                command: (id) => {  
                 this.$router.push({ name: "FlowAuditDayRoot",params:{auditday_id:id} })
                }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                command: (id) => {
                   this.deleteItem("auditday",id)
                }
            },

    	]
    }
  },
  mounted()
  {
    this.listdata = this.data
  },
  computed:{
  	dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      }
    },
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },

  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.$emit("dataDeleted")
      }
    },
    list(newval)
    {
      this.listdata = newVal
    }

  },
  methods:{  	
  	toggle(event,id) {      
      //return false
        this.$refs['menu'+id].toggle(event);
    },
  	end(event)
    {   
      let data = this.sanitizeArray(this.data)
      this.$emit("listupdated",data)
      

      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
  }

}
</script>

<style lang="css" scoped>
</style>